export const DISCOUNT_TYPES = {
    MILE: 'mile',
    PROMOCODE: 'promocode',
} as const;
